import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../../../utils/UtilsFormule";

const DataTableAccountImpayes = ({ listTransaction }) => {
  const { SearchBar } = Search;
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  function documentTypeFormatter(cell, row) {
    console.log("row", row);
    if (row.type === 0) {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-warning">
          Payement
        </span>
      );
    } 
  }

  function documentFormatter(cell, row) {
    console.log("row", row);
    if (row.factureSale !== null && row.factureSale !== undefined) {
      return (
        // <span style={{ cursor: "pointer" }} className="badge bg-warning">
        <>
          {" "}
          {row.factureSale.ref} -{row.factureSale.title}
        </>
        // </span>
      );
    } else if (row.retenuSource !== null) {
      return <> Retenu </>;
    } else if (row.payementInformation !== null) {
      return <> Payement</>;
    } else if (row.facture !== null) {
      return (
        <>
          {" "}
          {row.facture?.ref} -{row.facture?.title}
        </>
      );
    }
  }

  function detailsTitleFormatter(cell, row) {
      console.log("row", row);
      if (row.factureSale !== null&& row.factureSale!==undefined) {
          return (
              // <span style={{ cursor: "pointer" }} className="badge bg-warning">
                <> {row.factureSale.ref} -{row.factureSale.title}</>
              // </span>
          );
      } else if (row.retenuSource !== null){
          return (
             <> Retenu </>
          );
      }else if (row.payementInformation !== null){
          return (
              <> {detailsPayements(row.payementInformation)}
              </>
          );
      }else if (row.facture !== null) {
          return (
                <> {row.facture?.ref} -{row.facture?.title}</>
          );
      }
  }

  function detailsPayements(cell,row) {
    console.log("row", row);
    if (row.typePayement === "Virement") {
      return <>Virement : {row.numVirement} </>;
    } else if (row.typePayement === "Wallet") {
      return <>Wallet : {row.wallet.title} </>;
    } else if (row.typePayement === "Chéque / Traites") {
      return <>Chéque / Traites : {row.codeCheque} </>;
    } else if (row.typePayement === "Espéce") {
      return (
        <>
          Espéce : {row.ref}-{row.year}{" "}
        </>
      );
    } else if (row.typePayement === "En ligne") {
      return (
        <>
          Espéce : {row.ref}-{row.year}{" "}
        </>
      );
    }
  }

  function detailsButtonFormatter(cell, row) {
    console.log("row", row);
    if (row.factureSale !== null && row.factureSale !== undefined) {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-black btn-sm "
          onClick={() =>
            onViewProductsHandler(row.factureSale.ref, row.factureSale.id)
          }
        >
          <i class="fas fa-shopping-cart"></i>
        </button>
      );
    } else if (row.retenuSource !== null) {
      return <> Retenu </>;
    } else if (row.payementInformation !== null) {
      return <> {detailsPayements(row.payementInformation)}</>;
    } else if (row.facture !== null) {
      return (
        <>
          {" "}
          {row.facture?.ref} -{row.facture?.title}
        </>
      );
    }
  }
  const onViewProductsHandler = (refDocument, idDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "facture");
    localStorage.setItem("idBill", idDocument);

    const pdfWindow = window.open();
    pdfWindow.location.href = "/payerBillVente";
  };
  function amountFormatter(cell, row) {
    console.log("row", row);
    if (row.amountPayed !== null) {
      return <> {row.amountPayed} DNT</>;
    }
  }
  function dateFormatter(cell, row) {
    console.log("row", row);
    if (row.echeanceDate !== null) {
      return <> {UtilsFormule.formatDateHours(row.echeanceDate)} </>;
    }
  }
  const columns = [
    {
      dataField: "typePayement",
      text: "",
      align: "center",
      // formatter: documentTypeFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "Document",
      align: "center",
      formatter: detailsPayements,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    // {
    //     dataField: "id",
    //     text: "Info",
    //     align: "center",
    //     formatter: detailsTitleFormatter,
    //     headerAlign: "center",
    //     headerStyle: () => {
    //         return { width: "20%" };
    //     },
    // },
    {
      dataField: "id",
      text: "Montant",
      align: "center",
      formatter: amountFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "Date",
      align: "center",
      formatter: dateFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    // {
    //   dataField: "id",
    //   text: "Details",
    //   align: "center",
    //   formatter: detailsButtonFormatter,

    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "20%" };
    //   },
    // },
  ];
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les transactions </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listTransaction}
          columns={columns}
          // onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  // expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableAccountImpayes;
